import { useNavigate } from "react-router-dom";

const ViewService = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Service Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate(-1)}>Manage Services</button> - Service Detail
        </p>
      </div>

      <div className="cards view_page">
        {/* Service Info */}
        <div className="gap_p">
          <div className="w_33">   <h6>Service Name:</h6>
            <p>Service Example Name</p></div>
          <div className="w_33">  <h6>Service Description:</h6>
            <p>
              Description of the service, including details like what it
              includes, duration, and any special instructions.
            </p></div>
          <div className="w_33">  <h6>Service Price:</h6>
            <p>$150</p></div>
          <div className="w_33"> <h6>Price Type:</h6>
            <p>Hourly</p></div>
          <div className="w_33">  <h6>Tax (if applicable):</h6>
            <p>10%</p></div>
          <div className="w_33"> <h6>Maximum Bookings Per Slot/Day:</h6>
            <p>5 bookings</p></div>

          <div className="w_33">
            <h6>Category</h6>
            <p>Category Example</p>
          </div>
          <div className="w_33">
            <h6>Sub-category</h6>
            <p>Sub-category Example</p>
          </div>
          <div className="w_33">
            <h6>Duration</h6>
            <p>2 hours</p>
          </div>
          <div className="w_33">
            <h6>Availability</h6>
            <p>Monday, Wednesday, Friday</p>
          </div>
          <div className="w_100">
            <h6>Store Address</h6>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Error, a!</p>
          </div>

          <div className="w_100">
            <h6>Optional Extras or Add-ons</h6>
            <p>Deep cleaning, express service, etc.</p>
          </div>
          <div className="w_100">
            <h6>Service Images</h6>
            <div className="gap_p">
              <div className="w_33">
                <figure>

                  <img src="/static/images/placeholder.png" alt="Service Image 1" />
                </figure>


              </div>
              <div className="w_33">
                <figure>

                  <img src="/static/images/placeholder.png" alt="Service Image 1" />
                </figure>


              </div>
              <div className="w_33">
                <figure>

                  <img src="/static/images/placeholder.png" alt="Service Image 1" />
                </figure>


              </div>
              <div className="w_33">
                <figure>

                  <img src="/static/images/placeholder.png" alt="Service Image 1" />
                </figure>


              </div>
              <div className="w_33">
                <figure>

                  <img src="/static/images/placeholder.png" alt="Service Image 1" />
                </figure>


              </div>
            </div>




          </div>
        </div>
      </div>
    </>
  );
}
export default ViewService;
